export const PORTAL_MOBILE_BREAKPOINT_PX = 768;
export const PORTAL_VISUAL_VIEWPORT_OFFSET_TOP_PROPERTY =
	'--portal-visual-viewport-offset-top';
export const PORTAL_VISUAL_VIEWPORT_HEIGHT_PROPERTY =
	'--portal-visual-viewport-height';

export const normalizePortalVisualViewportOffsetTop = (offsetTop: unknown): number => {
	const value = typeof offsetTop === 'number' ? offsetTop : Number(offsetTop);
	if (!Number.isFinite(value)) {
		return 0;
	}
	return Math.max(0, Math.round(value));
};

export const getPortalVisualViewportOffsetTop = (options: {
	isMobile: boolean;
	offsetTop?: unknown;
}): number =>
	options.isMobile ? normalizePortalVisualViewportOffsetTop(options.offsetTop ?? 0) : 0;

export const formatPortalVisualViewportOffsetTop = (offsetTop: unknown): string =>
	`${normalizePortalVisualViewportOffsetTop(offsetTop)}px`;

export const shouldUpdatePortalVisualViewportOffsetTop = (
	currentValue: string | null | undefined,
	nextOffsetTop: unknown
): boolean => {
	const nextValue = formatPortalVisualViewportOffsetTop(nextOffsetTop);
	return String(currentValue ?? '').trim() !== nextValue;
};

export const normalizePortalVisualViewportHeight = (height: unknown): number => {
	const value = typeof height === 'number' ? height : Number(height);
	if (!Number.isFinite(value) || value <= 0) {
		return 0;
	}
	return Math.round(value);
};

export const getPortalVisualViewportHeight = (options: {
	isMobile: boolean;
	height?: unknown;
	fallbackHeight?: unknown;
}): number => {
	if (!options.isMobile) {
		return 0;
	}
	const height = normalizePortalVisualViewportHeight(options.height);
	if (height > 0) {
		return height;
	}
	return normalizePortalVisualViewportHeight(options.fallbackHeight);
};

export const formatPortalVisualViewportHeight = (height: unknown): string =>
	`${normalizePortalVisualViewportHeight(height)}px`;

export const shouldUpdatePortalVisualViewportHeight = (
	currentValue: string | null | undefined,
	nextHeight: unknown
): boolean => {
	const nextValue = formatPortalVisualViewportHeight(nextHeight);
	return String(currentValue ?? '').trim() !== nextValue;
};
